/** @format */
import { animated, useSpring } from '@react-spring/web';
import React, { FunctionComponent } from 'react';

// eslint-disable-next-line @mpb-com/mpb/require-types-file -- Legacy code: do not use as an example.
export type ChevronProps = {
    className?: string;
    // eslint-disable-next-line @typescript-eslint/naming-convention -- Legacy code: do not use as an example.
    inverted?: boolean;
};
export const Chevron: FunctionComponent<ChevronProps> = ({
    inverted = false,
    className,
}: ChevronProps) => {
    const leftLine = [
        'M0.121919 15.4785C-0.142544 14.9936 0.0361136 14.3862 0.520962 14.1217L11.521 8.12173C12.0058 7.85727 12.6132 8.03593 12.8777 8.52078C13.1422 9.00563 12.9635 9.61306 12.4787 9.87753L1.47867 15.8775C0.993818 16.142 0.386381 15.9633 0.121919 15.4785Z',
        'M0.212397 9.36058C0.489082 8.8826 1.10086 8.71941 1.57884 8.9961L12.423 15.2734C12.901 15.5501 13.0642 16.1618 12.7875 16.6398C12.5108 17.1178 11.899 17.281 11.421 17.0043L0.576874 10.727C0.0988945 10.4503 -0.0642871 9.83855 0.212397 9.36058Z',
    ];

    const rightLine = [
        'M11.1221 8.52083C11.3865 8.03598 11.994 7.85732 12.4788 8.12178L23.4788 14.1218C23.9637 14.3862 24.1423 14.9937 23.8779 15.4785C23.6134 15.9634 23.006 16.142 22.5211 15.8776L11.5211 9.87757C11.0363 9.61311 10.8576 9.00567 11.1221 8.52083Z',
        'M11.2122 16.6392C10.9355 16.1612 11.0988 15.5494 11.5768 15.2728L22.4215 8.99644C22.8995 8.7198 23.5112 8.88303 23.7879 9.36104C24.0645 9.83904 23.9013 10.4508 23.4233 10.7274L12.5786 17.0038C12.1006 17.2804 11.4888 17.1172 11.2122 16.6392Z',
    ];

    const animationProps = useSpring({
        leftLine: inverted ? leftLine[0] : leftLine[1],
        rightLine: inverted ? rightLine[0] : rightLine[1],
    });
    return (
        <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={className}
        >
            <g clipPath="url(#clip0_14574_117970)">
                <animated.path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d={animationProps.leftLine}
                />
                <animated.path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d={animationProps.rightLine}
                />
            </g>
            <defs>
                <clipPath id="clip0_14574_117970">
                    <rect width="24" height="24" />
                </clipPath>
            </defs>
        </svg>
    );
};
